import { useCallback, useEffect, useState } from "react";
import { loadMetaSdk } from "./embeddedSignup";

const idle = { status: "idle", error: "" };

export default function useMetaSdk(enabled) {
  const [state, setState] = useState(idle);
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt((value) => value + 1), []);

  useEffect(() => {
    if (!enabled) { setState(idle); return undefined; }
    let current = true;
    setState({ status: "loading", error: "" });
    loadMetaSdk().then(
      () => { if (current) setState({ status: "ready", error: "" }); },
      (error) => { if (current) setState({ status: "error", error: error.message || "No se pudo cargar Meta." }); },
    );
    return () => { current = false; };
  }, [enabled, attempt]);

  return { ...(enabled ? state : idle), retry };
}
